import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RatingModalComponent } from './rating-modal.component';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NzRateModule,
    NzIconModule,
    NzButtonModule,
    ReactiveFormsModule,
  ],
  declarations: [
    RatingModalComponent
  ],
  exports: [
    RatingModalComponent
  ],
})
export class RatingModalModule { }
